import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <img
        src={process.env.PUBLIC_URL + '/static/images/status/access-denied.svg'}
        alt="Access Denied"
        style={{ maxWidth: 350, marginBottom: 32 }}
      />
      <Typography variant="h3" gutterBottom color="primary">
        Access Denied
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
        Sorry, you do not have permission to view this page.<br />
        Please contact your administrator if you believe this is a mistake.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/')}>Go to Home</Button>
    </Box>
  );
};

export default AccessDenied; 